import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import {
  getApiPersonDetailImagesListQueryKey,
  useApiPersonDetailImagesList,
} from '@rover/rsdk/src/apiClient/latest/api-person-detail-images-list';
import type { Image } from '@rover/rsdk/src/apiClient/latest/model/image';
import type { PaginatedImageList } from '@rover/rsdk/src/apiClient/latest/model/paginatedImageList';

type GalleryReturnType = {
  data: Image[];
  count: number;
  onPaginate: () => void;
};

const useTrainerImages = ({ opk }): GalleryReturnType => {
  const queryClient = useQueryClient();

  const [page, setPage] = useState(1);

  const key = getApiPersonDetailImagesListQueryKey(opk, { page: 1, pageSize: 25 });
  const initialImages = queryClient.getQueryData(key) as PaginatedImageList | undefined;

  const [images, setImages] = useState<Image[]>(initialImages?.results || []);

  const { data: mediaList } = useApiPersonDetailImagesList(
    opk,
    { page, pageSize: 25 },
    { query: { onSuccess: (data) => setImages([...images, ...data.results!]) } }
  );

  const onPaginate = (): void => {
    if (mediaList?.next) {
      setPage(page + 1);
    }
  };

  const count = mediaList?.count || 0;

  return { data: images, count, onPaginate };
};

export default useTrainerImages;
